import React from "react";
import { Col, Form, Row } from "antd";
import { FileUploadUi } from "../../../ui/FileUploadUi";

export const RutaUploadForm = () => {
  return (
    <>
      <Row gutter={8}>
        <Col span={24}>
          <Form.Item label="Archivo" name="file">
            <FileUploadUi name="file" accept="application/json" maxCount={1} />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};
